<div class="gap-lg grid">
  @for (caracteristique of caracteristiques() | trierPar: 'nom'; track caracteristique.id) {
    <app-expansion-panel [titre]="caracteristique.nom" [item]="caracteristique">
      <div class="ml-sm" ngProjectAs="chipRight">
        <app-chip
          [label]="countSousCaracteristiquesSelectionnees(caracteristique) | i18nPlural: caracteristiqueMapping"
        />
      </div>
      <div class="grid">
        @for (
          sousCaracteristique of caracteristique.sousCaracteristiques | trierPar: 'nom';
          track sousCaracteristique.id;
          let last = $last
        ) {
          <app-checkbox-submenu-item [item]="sousCaracteristique" [formcontrol]="sousCaracteristiques" />
          @if (!last) {
            <div hlmItemSeparator></div>
          }
        } @empty {
          <div class="pl-md pr-xs py-xs">
            <span class="paragraph-medium-medium text-content-secondary"
              >Aucune sous-caractéristique liée à cette caractéristique.</span
            >
          </div>
        }
      </div>
    </app-expansion-panel>
  }
</div>
